// removed by extract-text-webpack-plugin
module.exports = {"container":"_4Z-M","image":"_26LD","background":"Aq7j","parallax":"MxD4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CaseStudy/Image/styles.scss
// module id = 532
// module chunks = 0